import * as React from 'react'
import { ReactElement, useState } from 'react'
import { TreeItem } from '@fluentui/react-components/unstable'
import { Button, Tooltip } from '@fluentui/react-components'
import { DeleteRegular } from '@fluentui/react-icons'
import { LineItemMutationDto } from '../../../../../config/finance/invoiceConfig'
import { LineItemGroupProps } from '../LineItemGroup/LineItemGroup'
import LineItem from './LineItem'
import { PricePrecedence } from '../../../../../config/finance/financeConfig'

type Props = LineItemGroupProps & { lineItem: LineItemMutationDto }

export default function AssignedLineItem(props: Props): ReactElement {
    const { lineItem } = props
    const [isDragged, setIsDragged] = useState(false)
    return (
        <TreeItem
            itemType="leaf"
            aria-level={0}
            draggable={props.isEditable}
            onDragStart={event => {
                event.stopPropagation()
                props.setCurrentLineItem(lineItem)
                setIsDragged(true)
            }}
            onDragEnd={() => setIsDragged(false)}
            style={{
                opacity: isDragged ? 0.5 : 1,
            }}
        >
            <LineItem
                {...props}
                lineItemType={lineItem?.type}
                lineItem={lineItem}
                entity={props.lineItemEntities.entityMap.get(lineItem?.entityId)}
                isSelected={props.invoice?.lineItemGroups.flatMap(group => group.lineItems).some(item => lineItem?.entityId === item.entityId)}
                showPrice={props.lineItemGroup.precedence === PricePrecedence.Inherited}
                findQuantity={props.lineItemEntities.findQuantity}
                getPrice={props.lineItemEntities.getPrice}
                isDraggable={props.isEditable}
                actions={
                    !props.isDragging && props.isEditable ? (
                        <Tooltip content="Verwijder factuurregel uit de groep" relationship="description" withArrow>
                            <Button size="small" appearance="transparent" icon={<DeleteRegular />} onClick={() => props.remove(props.index)} />
                        </Tooltip>
                    ) : undefined
                }
            />
        </TreeItem>
    )
}
